import { CallbackInterface } from 'recoil';
import { getBSolutionsWebSSORedirectUrl } from '../actions';
import {
  userLoaderState,
} from '../state';
import { setSnackbarError } from '../common';

export const handleBSolutionsWebSSORedirectCallback =
  ({ set }: CallbackInterface) =>
  async () => {
    set(userLoaderState, true);
    try {
      const res = await getBSolutionsWebSSORedirectUrl();
      window.open(res?.data?.ssoUrl, '_blank', 'noopener,noreferrer');
    } catch (error: any) {
      setSnackbarError(set, error);
    }
    set(userLoaderState, false);
  };